import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHomelessChartsDataContext } from './hooks/useHomelessChartsDataContext';

export const PermanenceTime = () => {
    const { chartData } = useHomelessChartsDataContext();

    return (
        <SimpleBars
            title={'Pessoa em Situação de Rua - Tempo de Permanência'}
            horizontal={true}
            subtitles={
                chartData?.permanenceTime?.map((item) => item.description) || []
            }
            values={chartData?.permanenceTime?.map((item) => item.total  ||  0) || []}
        />
    );
};
